import { History } from "history";
import { ROUTES } from "../../../../AppRouter";
import * as React from "react";
import { useContext } from "react";
import { AppContext, IAppContext } from "../../../../context/AppContext";
import {
  fetchDeduction,
  saveDeduction
} from "../../api/deduction/DeductionApi";
import {
  DeductionModel,
  DeductionModelErrors
} from "../../../employee/service/deduction/DeductionModel";
import { DeductionView } from "./DeductionView";
import { fieldValidation } from "../../../../common/Model";
import { required } from "../../../../common/validation/RequiredValidator";
import DeductionType from "../../api/DeductionType";
import DeductionCalculationMethod from "../../api/DeductionCalculationMethod";
import StpType from "../../api/StpType";
import { CrudForm } from "../../../../components/widgets/CrudForm";
import DeductionLimitType from "../../api/DeductionLimitType";

interface DeductionPageProps {
  match: any;
  history: History;
}

const validators = [
  fieldValidation("name", [required]),
  fieldValidation("displayName", [required])
];

const DeductionPage: React.FC<DeductionPageProps> = ({ history, match }) => {
  const { appState } = useContext<IAppContext>(AppContext);
  const initialModel = {
    name: "",
    displayName: "",
    type: DeductionType.NORMAL,
    calculationMethod: DeductionCalculationMethod.FIXED_AMOUNT,
    limitType: DeductionLimitType.NO_LIMIT,
    limitCalculationMethod: DeductionCalculationMethod.FIXED_AMOUNT,
    stpType: StpType.GROSS_PAYMENTS,
    taxable: true,
    amount: 0.0,
    employees: [],
    isValid: false,
    errors: {} as DeductionModelErrors
  } as DeductionModel;

  return (
    <CrudForm
      id={match.params.id}
      businessId={appState.currentBusinessId}
      validators={validators}
      initialModel={initialModel}
      history={history}
      entityName="deduction"
      FormViewComponent={DeductionView}
      saveModel={saveDeduction}
      fetchModel={fetchDeduction}
      listRoute={ROUTES.DEDUCTION_LIST}
    />
  );
};

export { DeductionPage };
